// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TwitterLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M31.386 8.426A1.501 1.501 0 0 0 30 7.5h-3.523a6.59 6.59 0 0 0-5.458-3 6.356 6.356 0 0 0-4.575 1.856A6.483 6.483 0 0 0 14.5 11v.098C9.896 9.65 6.203 5.984 6.163 5.944a1.5 1.5 0 0 0-2.56.922c-.788 8.771 3.082 13.474 5.258 15.39-1.811 1.848-4.361 2.829-4.386 2.839a1.5 1.5 0 0 0-.725 2.238C4 27.692 5.43 29.5 10 29.5c9.031 0 16.587-6.907 17.45-15.829l3.61-3.61a1.5 1.5 0 0 0 .326-1.635ZM24.94 11.94a1.49 1.49 0 0 0-.436.965C24.017 20.529 17.647 26.5 10 26.5c-.522.003-1.044-.03-1.561-.099 1.311-.832 2.776-2.017 3.811-3.569a1.5 1.5 0 0 0-.488-2.125c-.014-.008-1.54-.936-2.928-3.052s-2.158-4.625-2.308-7.473C8.671 11.8 12 13.85 15.75 14.48A1.5 1.5 0 0 0 17.5 13v-2a3.5 3.5 0 0 1 1.051-2.509 3.383 3.383 0 0 1 2.432-.991 3.604 3.604 0 0 1 3.227 2.101 1.5 1.5 0 0 0 1.375.899h.79l-1.435 1.44Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
